const PaymentSchedule = ({ paymentSchedule = [] }) => {
  if (!paymentSchedule?.length) return null; 

  // Sort by order just to ensure correct sequence
  const sorted = [...paymentSchedule].sort((a, b) => a.order - b.order);

  // Split into two balanced columns
  const mid = Math.ceil(sorted.length / 2);
  const leftColumn = sorted.slice(0, mid);
  const rightColumn = sorted.slice(mid);

  const formatPercentage = (value) => (value ? `${value}%` : "");

  return (
    <div className="w-full">
      <div className="mx-auto bg-white p-6 md:p-8 border rounded-lg">
        {/* Heading */}
        <h2 className="font-medium text-[#031722] tracking-[0.01em] text-lg sm:text-xl md:text-2xl lg:text-[24px] mb-4">
          Payment Schedule
        </h2>

        {/* Divider */}
        <div className="border-b-2"></div>

        {/* Two Column Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 mt-4">
          {/* Left Column */}
          <div>
            <ul className="space-y-4">
              {leftColumn.map((item, index) => (
                <li key={index} className="flex gap-3">
                  <span className="font-normal text-[#858585] tracking-[0.01em] text-[16px]">
                    •
                  </span>
                  <span className="text-gray-500 text-base md:text-lg">
                    <span className="font-normal text-[#858585] tracking-[0.01em] text-[16px]">
                      {item.stage}
                    </span>
                    {item.percentage && (
                      <span className="text-gray-500">
                        {" "}
                        - {formatPercentage(item.percentage)}
                      </span>
                    )}
                    {item.description && (
                      <span className="block text-xs text-gray-400 mt-1 leading-tight">
                        {item.description}
                      </span>
                    )}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right Column */}
          <div>
            <ul className="space-y-4">
              {rightColumn.map((item, index) => (
                <li key={index} className="flex gap-3">
                  <span className="font-normal text-[#858585] tracking-[0.01em] text-[16px]">
                    •
                  </span>
                  <span className="text-gray-500 text-base md:text-lg">
                    <span className="font-normal text-[#858585] tracking-[0.01em] text-[16px]">
                      {item.stage}
                    </span>
                    {item.percentage && (
                      <span className="text-gray-500">
                        {" "}
                        - {formatPercentage(item.percentage)}
                      </span>
                    )}
                    {item.description && (
                      <span className="block text-xs text-gray-400 mt-1 leading-tight">
                        {item.description}
                      </span>
                    )}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSchedule;
